const cards = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20scene%20with%20warm%20crimson%20red%20abstract%20lighting%2C%20dramatic%20spotlight%20effect%20on%20a%20textured%20dark%20background%2C%20editorial%20magazine%20aesthetic%2C%20mysterious%20atmosphere%2C%20no%20text%20no%20faces%20no%20people%2C%20stylized%20abstract%20composition&width=400&height=280&seq=card-hot-01&orientation=squarish",
    tag: '顶流恋情',
    title: '当红小生深夜约会神秘女郎，恋情曝光引发粉丝集体塌房',
    heat: '98.7万',
    time: '2小时前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20backstage%20scene%20with%20warm%20golden%20amber%20light%20leaking%20through%20gaps%2C%20textured%20industrial%20walls%2C%20cinematic%20mood%20lighting%2C%20editorial%20photography%20style%2C%20suspenseful%20atmosphere%2C%20no%20text%20no%20faces%20no%20people&width=400&height=280&seq=card-hot-02&orientation=squarish",
    tag: '综艺争议',
    title: '热门综艺录制现场导演与嘉宾激烈争执，节目组连夜删减镜头',
    heat: '76.3万',
    time: '5小时前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20abstract%20city%20night%20scene%20with%20neon%20red%20glow%20reflections%20on%20wet%20pavement%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20noir%20style%2C%20mysterious%20urban%20vibe%2C%20no%20text%20no%20faces%20no%20people%2C%20grainy%20texture&width=400&height=280&seq=card-hot-03&orientation=squarish",
    tag: '网红翻车',
    title: '百万粉丝美妆博主涉嫌虚假宣传，质检报告被扒产品含违禁成分',
    heat: '65.2万',
    time: '8小时前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20dark%20elegant%20theater%20stage%20with%20a%20single%20warm%20crimson%20spotlight%2C%20empty%20velvet%20seats%20in%20shadow%2C%20dramatic%20composition%2C%20editorial%20photography%2C%20mysterious%20and%20theatrical%20mood%2C%20no%20text%20no%20faces%20no%20people&width=400&height=280&seq=card-hot-04&orientation=squarish",
    tag: '娱乐圈内幕',
    title: '某经纪公司内部邮件泄露，多位艺人合约条款不公平引发行业震动',
    heat: '54.8万',
    time: '12小时前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20cracked%20glass%20texture%20and%20warm%20red%20amber%20light%20shining%20through%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20tense%20mood%2C%20no%20text%20no%20faces%20no%20people%2C%20abstract%20minimalist&width=400&height=280&seq=card-hot-05&orientation=squarish",
    tag: '选秀黑幕',
    title: '某选秀节目投票系统被曝暗箱操作，粉丝晒出数据异常证据链',
    heat: '43.1万',
    time: '1天前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20dark%20luxurious%20interior%20with%20warm%20golden%20candlelight%20reflections%20on%20polished%20surfaces%2C%20mysterious%20shadowy%20corners%2C%20dramatic%20chiaroscuro%20lighting%2C%20editorial%20photography%2C%20intriguing%20atmosphere%2C%20no%20text%20no%20faces%20no%20people&width=400&height=280&seq=card-hot-06&orientation=squarish",
    tag: '直播互撕',
    title: '两大头部主播隔空互怼升级，互相爆料对方团队刷单买粉实锤',
    heat: '38.5万',
    time: '1天前',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20scattered%20paper%20documents%20on%20a%20wooden%20surface%2C%20warm%20desk%20lamp%20light%2C%20dramatic%20shadows%2C%20investigative%20journalism%20aesthetic%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people%2C%20mysterious&width=400&height=280&seq=card-hot-07&orientation=squarish",
    tag: '独家爆料',
    title: '某影视公司财务问题浮出水面，多部待播剧面临搁浅风险',
    heat: '31.2万',
    time: '2天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网热度最高的黑料吃瓜内容精选</p>
          </div>
          <a
            href="#ranking"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer no-underline"
          >
            查看完整热度榜 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 7).map((card, i) => (
            <article
              key={i}
              className={`bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-colors group cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'aspect-[21/9]' : 'aspect-[4/3]'} overflow-hidden`}>
                <img
                  src={card.img}
                  alt={card.title}
                  onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[11px] font-semibold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className={`font-semibold text-foreground-900 leading-relaxed mb-3 group-hover:text-primary-600 transition-colors ${
                  i === 0 ? 'text-base md:text-lg' : 'text-sm'
                }`}>
                  {card.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.heat} 热度
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}